import React from 'react';
import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content';
import _ from 'lodash';

import { AnalyticsContextProvider } from '@nerdwallet/structured-content/contexts/AnalyticsContext';
import {
  useSegmentAnalytics,
  useAnalyticsPageView,
} from '@nerdwallet/seo-analytics';
import { stringInputSpec, boolCheckboxSpec } from '../../lib/editing-configs';

const HomeInsuranceClickTableWrapper = ({
  inventoryType,
  title,
  quinstreetSrcId,
  fetchOffersOnLoad,
  zipCode,
  disableGeolocation,
}) => {
  const { pageViewId, pageViewReady, pageName } = useAnalyticsPageView();
  const segmentInstance = useSegmentAnalytics();

  const analytics = {
    segmentAttributes: {
      driverPageName: pageName,
      pageViewId,
      pageViewReady,
      segmentInstance: segmentInstance.analytics,
    },
  };
  return (
    <AnalyticsContextProvider value={analytics}>
      <StructuredContent>
        {{
          type: 'HomeInsuranceClickTable',
          version: '1.0.0',
          props: {
            inventoryType,
            title,
            quinstreetSrcId,
            fetchOffersOnLoad,
            zipCode,
            disableGeolocation,
          },
        }}
      </StructuredContent>
    </AnalyticsContextProvider>
  );
};

HomeInsuranceClickTableWrapper.propTypes = {
  inventoryType: PropTypes.string,
  title: PropTypes.string,
  quinstreetSrcId: PropTypes.string,
  fetchOffersOnLoad: PropTypes.bool,
  zipCode: PropTypes.string,
  disableGeolocation: PropTypes.bool,
};

HomeInsuranceClickTableWrapper.defaultProps = {
  title: 'Compare homeowners insurance',
  quinstreetSrcId: '662940',
  fetchOffersOnLoad: true,
  zipCode: '',
  disableGeolocation: false,
};

HomeInsuranceClickTableWrapper.getEditingConfig = (componentDocument) => {
  if (
    componentDocument?.props &&
    !('fetchOffersOnLoad' in componentDocument?.props)
  ) {
    _.set(componentDocument, 'props.fetchOffersOnLoad', true);
  }
  return [
    stringInputSpec('title', 'Title'),
    stringInputSpec('quinstreetSrcId', 'Quinstreet Src Id'),
    stringInputSpec('zipCode', 'Zip Code'),
    stringInputSpec('inventoryType', 'Inventory Type'),
    boolCheckboxSpec('fetchOffersOnLoad', 'Fetch Offers on Load'),
    boolCheckboxSpec('disableGeolocation', 'Disable Geolocation'),
  ];
};

HomeInsuranceClickTableWrapper.displayName = 'HomeInsuranceClickTableWrapper';

export default HomeInsuranceClickTableWrapper;
